import {GetWalletResponse_Tab_Coins_CoinsHeader} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.types';
import {useMemo, useRef} from 'react';

/**
 * Determines when progress bars should animate with bounce effect.
 * Returns true only when progressBars array changes (e.g., when bonus is claimed),
 * not on every render or initial mount.
 */
export const useShouldAnimateProgressBars = (
  deprecatedProgressBars: GetWalletResponse_Tab_Coins_CoinsHeader['deprecatedProgressBars'],
) => {
  const previousProgressBars = useRef(deprecatedProgressBars);
  const isFirstRender = useRef(true);

  return useMemo(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      previousProgressBars.current = deprecatedProgressBars;
      return false;
    }

    const hasChanged = deprecatedProgressBars.some((bar, index) => {
      const prevBar = previousProgressBars.current[index];
      return (
        !prevBar ||
        bar.availablePercentage !== prevBar.availablePercentage ||
        bar.pendingPercentage !== prevBar.pendingPercentage ||
        bar.isCurrent !== prevBar.isCurrent
      );
    });

    previousProgressBars.current = deprecatedProgressBars;
    return hasChanged;
  }, [deprecatedProgressBars]);
};
